<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 14:57:15
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 14:17:31
-->
<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 09:10:08
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 09:15:38
-->

<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
				},
				responseCode: {
					"data": {
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台根据券编码发放商家券",
					t_url: this.commonUrls.test + "sendCouponByCouponCode",
					p_url: this.commonUrls.prod + "sendCouponByCouponCode",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'parkCode',info2: '否',info3: 'String',info4: '车场编号'},
							{info1: 'grantUserId',info2: '否',info3: 'String',info4: '发放的用户id'},
							{info1: 'couponCode',info2: '是',info3: 'String',info4: '券编码'},
							{info1: 'carNo',info2: '是',info3: 'String',info4: '车牌号码'},
              { info1: 'carCodeColor', info2: '否', info3: 'Integer', info4: '车牌颜色（1蓝色，2黄色，3白色，4黑色，5绿色），默认1蓝色' },
							{info1: 'parkingCode',info2: '否',info3: 'String',info4: '停车记录编号'},
							{info1: 'isFixedQrCode',info2: '否',info3: 'String',info4: '二维码'},
							{info1: 'origin',info2: '否',info3: 'String',info4: '0未定义,1动态扫码'},

					 ]
					}],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
									{ info1: 'couponTemplate', info2: '是', info3: 'JSONObject', info4: '券模板' },
									{ info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
									{ info1: 'cardNo', info2: '否', info3: 'String', info4: '卡号' },
									{ info1: 'grantTime', info2: '是', info3: 'String', info4: '发放时间yyyyMMddHHmmss' },
									{ info1: 'parkCodes', info2: '是', info3: 'String[]', info4: '适用车场数组' },
									{ info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券编码' },
									{ info1: 'validFrom', info2: '是', info3: 'String', info4: '有效期开始时间yyyyMMddHHmmss' },
									{ info1: 'validTo', info2: '是', info3: 'String', info4: '有效期结束时间yyyyMMddHHmmss' },
									{ info1: 'userId', info2: '是', info3: 'Long', info4: '用户id' },
									{ info1: 'grantType', info2: '是', info3: 'Integer', info4: '0车牌发放；1扫码发放；2卡票号发放' },
									{ info1: 'traderCode', info2: '是', info3: 'String', info4: '商家编码' },
									{ info1: 'traderName', info2: '是', info3: 'String', info4: '商家名称' },
									{ info1: 'operateType', info2: '是', info3: 'Integer', info4: '0商家发券 1中央发券' },

						]
					},{
						titleName: "couponTemplate",
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
									{ info1: 'code', info2: '是', info3: 'Long', info4: '券模板编码' },
									{ info1: 'name', info2: '是', info3: 'String', info4: '券模板名称' },
									{ info1: 'couponType', info2: '是', info3: 'String', info4: '券类型(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)' },
									{ info1: 'originalPrice', info2: '是', info3: 'String', info4: '券原价' },
									{ info1: 'realPrice', info2: '是', info3: 'String[]', info4: '折扣价' },
									{ info1: 'useRule', info2: '是', info3: 'String', info4: '使用规则' },
									{ info1: 'userRuleFrom', info2: '是', info3: 'String', info4: '使用规则金额最小值' },
									{ info1: 'useRuleTo', info2: '是', info3: 'String', info4: '使用规则金额最大值' },
									{ info1: 'isCover', info2: '是', info3: 'String', info4: '是否可用叠加使用' },
									{ info1: 'maxCoverNum', info2: '是', info3: 'String', info4: '最大叠加数' },
									{ info1: 'remark', info2: '是', info3: 'String', info4: '备注' },
									{ info1: 'couponRule', info2: '是', info3: 'String', info4: '优惠规则' },
									{ info1: 'useParkingFee', info2: '是', info3: 'String', info4: '' },
									{ info1: 'extraProperty', info2: '是', info3: 'String', info4: '额外属性' },
									{ info1: 'faceValue', info2: '是', info3: 'String', info4: '面值' },


						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/sendCouponByCouponCode.vue